// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canRemoveWifAuthBinding } from "./check";

export function useCanRemoveWifAuthBinding(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canRemoveWifAuthBinding(withinScope);
  return canDoAction;
}
